(() => {
  'use strict';
  const shell = document.getElementById('sgx-shell');
  if (!shell) return;
  const path = location.pathname.replace(/\/+$/, '') || '/';
  const route = path === '/' ? 'home' : path.startsWith('/collections') || path.startsWith('/products') ? 'shop' : path === '/pages/tools' ? 'tools' : path === '/pages/videos' ? 'videos' : path === '/music' || path === '/pages/music' ? 'radio' : path === '/gallery' || path === '/pages/gallery' ? 'gallery' : path === '/cart' ? 'cart' : '';
  shell.querySelectorAll('[data-sgx-route]').forEach(item => {
    item.classList.toggle('is-active', item.dataset.sgxRoute === route);
    if (item.dataset.sgxRoute === route) item.setAttribute('aria-current', 'page');
    else item.removeAttribute('aria-current');
  });

  const playlistId = 'PLKiolPYwzTX0';
  const stateKey = 'sgx-radio-state-v1';
  const titleKey = 'sgMusicTitles:' + playlistId + ':v5';
  const trigger = shell.querySelector('[data-sgx-radio-trigger]');
  const drawer = shell.querySelector('.sgx-radio-drawer');
  const backdrop = shell.querySelector('.sgx-radio-backdrop');
  const close = shell.querySelector('[data-sgx-radio-close]');
  const mount = shell.querySelector('.sgx-radio-mount');
  const mini = shell.querySelector('.sgx-now-playing');
  const miniTitle = shell.querySelector('[data-sgx-mini-title]');
  const drawerTitle = shell.querySelector('[data-sgx-drawer-title]');
  const list = shell.querySelector('[data-sgx-song-list]');
  const playerHost = shell.querySelector('[data-sgx-player]');
  let player = null, ids = [], titles = {}, saved = {}, playing = false, ticker = null;
  try { titles = JSON.parse(localStorage.getItem(titleKey) || '{}') || {}; } catch (_) {}
  try { saved = JSON.parse(sessionStorage.getItem(stateKey) || '{}') || {}; } catch (_) {}

  function save() {
    try { sessionStorage.setItem(stateKey, JSON.stringify(saved)); } catch (_) {}
  }
  function showMini() {
    mini.hidden = !saved.id;
    miniTitle.textContent = titles[saved.id] || saved.title || 'Slot Grill Radio';
    drawerTitle.textContent = miniTitle.textContent;
    shell.dataset.radioPlaying = playing ? 'true' : 'false';
  }
  function open() {
    backdrop.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    shell.dataset.radioOpen = 'true';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (!player) loadAPI();
    close.focus();
  }
  function shut() {
    shell.dataset.radioOpen = 'false';
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.hidden = true;
    if (trigger) trigger.focus();
  }
  if (trigger) trigger.addEventListener('click', e => { e.preventDefault(); shell.dataset.radioOpen === 'true' ? shut() : open(); });
  close.addEventListener('click', shut);
  backdrop.addEventListener('click', shut);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && shell.dataset.radioOpen === 'true') shut(); });
  shell.querySelector('[data-sgx-mini-open]').addEventListener('click', open);

  function remember() {
    if (!player) return;
    try {
      const data = player.getVideoData() || {};
      if (data.video_id) {
        saved.id = data.video_id;
        saved.title = data.title || titles[saved.id] || saved.title;
        saved.seconds = Math.floor(player.getCurrentTime() || 0);
        save(); showMini();
      }
    } catch (_) {}
  }
  function select(id, index, seconds = 0) {
    if (!player) return;
    saved = { id, title: titles[id] || 'Slot Grill Radio', seconds };
    save(); showMini();
    try { player.loadPlaylist({ list: playlistId, listType: 'playlist', index, startSeconds: seconds }); }
    catch (_) { player.loadVideoById({ videoId: id, startSeconds: seconds }); }
  }
  function move(delta) {
    const index = ids.indexOf(saved.id);
    if (!ids.length || index < 0) { open(); return; }
    select(ids[(index + delta + ids.length) % ids.length], (index + delta + ids.length) % ids.length);
  }
  shell.querySelector('[data-sgx-prev]').addEventListener('click', () => move(-1));
  shell.querySelector('[data-sgx-next]').addEventListener('click', () => move(1));
  shell.querySelector('[data-sgx-play]').addEventListener('click', () => {
    if (!player) { open(); return; }
    if (playing) player.pauseVideo();
    else if (saved.id) {
      if (shell.dataset.radioOpen !== 'true') open();
      const index = ids.indexOf(saved.id);
      if (index >= 0 && !playing) select(saved.id, index, saved.seconds || 0);
      else player.playVideo();
    } else open();
  });

  function rows() {
    list.replaceChildren();
    ids.forEach((id, index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'sgx-song-row';
      button.textContent = String(index + 1).padStart(2, '0') + '  ' + (titles[id] || 'Song ' + (index + 1));
      button.addEventListener('click', () => select(id, index));
      list.appendChild(button);
    });
  }
  async function hydrate() {
    await Promise.all(ids.filter(id => !titles[id]).map(async id => {
      try {
        const url = 'https://www.youtube.com/watch?v=' + encodeURIComponent(id);
        const response = await fetch('https://www.youtube.com/oembed?format=json&url=' + encodeURIComponent(url), { credentials: 'omit' });
        if (response.ok) titles[id] = (await response.json()).title;
      } catch (_) {}
    }));
    try { localStorage.setItem(titleKey, JSON.stringify(titles)); } catch (_) {}
    rows(); showMini();
  }
  function ready() {
    player = new YT.Player(playerHost, {
      width: '410', height: '231',
      playerVars: { listType: 'playlist', list: playlistId, rel: 0, playsinline: 1, autoplay: 0, loop: 1 },
      events: {
        onReady() {
          let tries = 0;
          (function getSongs() {
            try { ids = player.getPlaylist() || []; } catch (_) {}
            if (ids.length) { rows(); hydrate(); showMini(); return; }
            if (tries++ < 30) setTimeout(getSongs, 150);
            else list.textContent = 'Songs could not load. Close Radio and try again.';
          })();
        },
        onStateChange(event) {
          playing = event.data === YT.PlayerState.PLAYING;
          remember(); showMini();
          if (playing && !ticker) ticker = setInterval(remember, 3000);
          if (!playing && ticker) { clearInterval(ticker); ticker = null; }
        }
      }
    });
  }
  function loadAPI() {
    if (window.YT && YT.Player) { ready(); return; }
    const prior = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => { if (typeof prior === 'function') prior(); ready(); };
    if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(script);
    }
  }
  window.addEventListener('pagehide', remember);
  if (saved.id) { saved.seconds = saved.seconds || 0; showMini(); loadAPI(); }
  else mini.hidden = true;
})();
